type CertificateStatus =
  | 'EMITTED'
  | 'REGISTERED'
  | 'ABORTED'
  | 'SUSPENDED'
  | 'REVOKED'
  | 'EXPIRED'
  | 'INVALID'
  | 'NOT_VALID';
type CertificateType =
  | 'REMOTE_SIGN'
  | 'AUTOMATIC_SIGN'
  | 'NOT_VALID'
  | 'INVALID';
type OtpType = 'PUSH' | 'SMS' | 'HARDWARE' | 'VASCO' | 'EXTERNAL';

//TODO aggiungere campi
export interface UserCertificate {
  certId: string;
  otpType: OtpType;
  certificateStatus: CertificateStatus;
  certificateType: CertificateType;
  active: boolean;
  certificateInfo: CertificateInfo;
  validityFrom: string;
  validityTo: string;
  renewable: boolean;
  email: string;
  telephone: string;
  aliasCertificate: string;
  domain: string;
}

export interface CertificateInfo {
  subjectDN: SubjectDN;
  subjectDnMap: SubjectDnMap;
  serialNumber: string;
  issuerDN: IssuerDN;
}

export interface IssuerDN {
  SERIALNUMBER: string;
  C: string;
  CN: string;
  O: string;
  OU: string[];
}

export interface SubjectDN {
  dnQualifier: string;
  G: string;
  SERIALNUMBER: string;
  C: string;
  CN: string;
  O: string;
  OU: any[];
  SN: string;
  D: string;
  T: string;
}

export interface SubjectDnMap {
  country: string;
  commonName: string;
  serialNumber: string;
  dnQualifier: string;
  surname: string;
  givenName: string;
  organization: string;
  description: string;
  title: string;
  organizationIdentifier: string;
}

//Enum generato dalle chiavi di SubjectDnMap
export enum SubjectDnMapKeys {
  COUNTRY = 'country',
  COMMON_NAME = 'commonName',
  SERIAL_NUMBER = 'serialNumber',
  DN_QUALIFIER = 'dnQualifier',
  SURNAME = 'surname',
  GIVEN_NAME = 'givenName',
  ORGANIZATION = 'organization',
  DESCRIPTION = 'description',
  TITLE = 'title',
  ORGANIZATION_IDENTIFIER = 'organizationIdentifier',
}

export interface CertificateListItem {
  certId: string;
  otpType: 'PUSH' | 'SMS' | 'HARDWARE' | 'VASCO' | 'EXTERNAL';
  uida: string;
}

export interface CertificateList {
  subjectName: string;
  cf: string;
  profileName: string;
  dnq: string;
  issuanceDate: string;
  notAfter: string;
  uap: string;
  CF: string;
  status:
    | 'active'
    | 'to_activate'
    | 'expiring'
    | 'expired'
    | 'revoked'
    | 'disabled'
    | 'suspended';
}

export interface ActionReportResponse {
  applicationID: string;
  serviceID: string;
  generateDate: string;
  logs: ReportLogs[];
}

export interface ReportLogs {
  value: {
    operationID: string;
    executeDate: string;
    result: string;
    subject: string;
    note: string;
  };
}

export interface Tokens {
  createdAt: string;
  description: string;
  expirationDate: string;
  id: number;
  name: string;
  remainingSignatures?: number;
  signatures?: number;
  status: string;
  userId: string;
}

export type RenewalState =
  | 'NOT_RENEWABLE'
  | 'RENEWABLE'
  | 'CONTRACT_SIGNED'
  | 'WAITING_PAYMENT_CONFIRMATION'
  | 'READY_TO_EMIT'
  | 'RENEWED';

export interface RenewalData {
  state?: RenewalState; //non triss state
  status?: RenewalState; //triss state
  migration?: boolean;
  payment?: boolean;
  stellantis?:boolean;
  resetSession?: boolean;
  certId?: string;
  //[key: string]: any;
  noPayment?: boolean; //pagamento triss
}

export default UserCertificate;
